import { useAuth } from './auth';

export function usePermission() {
  const { permissoes, user } = useAuth();

  const can = (modulo) => {
    if (!permissoes) return true;

    if (user?.Login === 'suporte@unitechsistemas.com') return true;

    return permissoes.includes(modulo);
  };

  const canAny = (...modulos) => modulos.some(can);

  return { can, canAny, permissoes };
}
